import { ArrowLeft } from "lucide-react";

interface RevisedRfiHeaderProps {
  onBackToUpdateRfi?: () => void;
}

export function RevisedRfiHeader({
  onBackToUpdateRfi,
}: RevisedRfiHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-2xl font-semibold tracking-tight text-foreground">
        Revised RFI
      </h1>
      {onBackToUpdateRfi && (
        <button
          className="inline-flex items-center hover:bg-[#FAF9F6] transition-all"
          onClick={onBackToUpdateRfi}
          style={{
            gap: 5,
            height: 32,
            padding: "0 12px",
            borderRadius: 6,
            border: "1px solid #E5E5E5",
            background: "#FFFFFF",
            color: "#52524E",
            fontSize: 12.5,
            fontWeight: 500,
          }}
        >
          <ArrowLeft style={{ width: 14, height: 14 }} />
          Back to Update RFI
        </button>
      )}
    </div>
  );
}
